export default {
  apiKey: 'AIzaSyACFdCbulkHANt7bOjbdYdmGb4UGJO88NQ',
  authDomain: 'gcp-zbk-superapp-dev-01-prj.firebaseapp.com',
  projectId: 'gcp-zbk-superapp-dev-01-prj',
  storageBucket: 'gcp-zbk-superapp-dev-01-prj.appspot.com',
  messagingSenderId: '840273825117',
  appId: '1:840273825117:web:6dd05c52607bcc42cb6cb4',
};
